import { render } from "./OrderPillSkeleton.vue?vue&type=template&id=ca66b646"
import script from "./OrderPillSkeleton.vue?vue&type=script&lang=ts"
export * from "./OrderPillSkeleton.vue?vue&type=script&lang=ts"
script.render = render

export default script